import { render, staticRenderFns } from "./ReportDesktopMoreCredit.vue?vue&type=template&id=36e318dc"
import script from "./ReportDesktopMoreCredit.vue?vue&type=script&lang=js"
export * from "./ReportDesktopMoreCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports